import { useQuery } from 'react-query'
import { getMerchantVideoRequests } from '../apis/video-requests.api'

export function useVideoRequestsQuery(merchantId: string) {
  return useQuery({
    queryKey: ['merchantVideoRequests'],
    queryFn: () => getMerchantVideoRequests(merchantId),
  })
}
